import {
  UserOutlined,
  SafetyCertificateOutlined,
  ToolOutlined,
} from "@ant-design/icons";

const UserRoleIcon = ({ role }) => {
  if (role === "super") {
    return <SafetyCertificateOutlined />;
  }

  if (role === "admin") {
    return <ToolOutlined />;
  }

  if (role === "user") {
    return <UserOutlined />;
  }

  return <></>;
};

export default UserRoleIcon;
